// src/index.js
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./index.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";

import { AuthProvider } from "./components/auth/AuthProvider";   // from step 1
import ProtectedRoute from "./components/auth/protectedRoute"; // from step 2
import AccessControl from "./components/auth/AccessControl"; // from step 3

import App from "./App";
import Login from "./components/auth/login";
import Register from "./components/auth/register";
import Account from "./components/user/account";
import ChartsPage from "./components/charts/ChartsPage";
import CallsPage from "./components/calls/CallsPage";
import PerformanceMetricsPage from "./components/charts/PerformanceMetricsPage";

import { unregister } from "./registerServiceWorker";

function Root() {
  useEffect(() => {
    // Clear localStorage items each time new user data arrives
    localStorage.removeItem("assetSearch");
    localStorage.removeItem("assetTypeSearch");
    localStorage.removeItem("assetFieldSearch");
    localStorage.removeItem("highlightedMarkers");

  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AccessControl requiredModule="map">
                  <App />
                </AccessControl>
              </ProtectedRoute>
            }
          />
          <Route
            path="/map"
            element={
              <ProtectedRoute>
                <AccessControl requiredModule="map">
                  <App />
                </AccessControl>
              </ProtectedRoute>
            }
          />
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <Account />
              </ProtectedRoute>
            }
          />
          <Route
            path="/charts"
            element={
              <ProtectedRoute>
                <AccessControl requiredModule="map">
                  <ChartsPage />
                </AccessControl>
              </ProtectedRoute>
            }
          />
          <Route
            path="/performance-metrics"
            element={
              <ProtectedRoute>
                <AccessControl requiredModule="map">
                  <PerformanceMetricsPage />
                </AccessControl>
              </ProtectedRoute>
            }
          />
          <Route
            path="/calls"
            element={
              <ProtectedRoute>
                <AccessControl requiredModule="calls">
                  <CallsPage />
                </AccessControl>
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<h1>Not Found</h1>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

// React 18+ root
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);

// If you want to disable service workers:
unregister();
